import SEO from "../components/common/SEO";
import PageHero from "../components/common/PageHero";
import { StaggerGroup } from "../components/common/Reveal";
import ServiceCard from "../components/cards/ServiceCard";
import CTASection from "../components/common/CTASection";
import { useContent } from "../context/ContentContext";

export default function Services() {
  const { services } = useContent();
  return (
    <>
      <SEO
        title="Technology Consulting & Talent Services"
        description="AI, data engineering, cloud, DevOps, enterprise applications, engineering and IT staffing services from AMVI Technologies."
        path="/services"
      />
      <PageHero
        eyebrow="Services"
        title="Technology & Talent Solutions"
        subtitle="Six connected practice areas that help enterprises build, modernize and scale — powered by deep technology capability and specialized talent."
      />
      <section className="px-6 pb-8">
        <StaggerGroup className="mx-auto grid max-w-7xl grid-cols-1 gap-6 lg:grid-cols-12" stagger={0.08}>
          {services.map((s) => (
            <ServiceCard key={s.slug} service={s} />
          ))}
        </StaggerGroup>
      </section>
      <CTASection />
    </>
  );
}
